/**
 * Hauptnavigation (Anf. 28/54).
 *
 * Sechs Reiter unter der Kopfzeile, in der Reihenfolge, in der man sie
 * braucht. Kalender, Aufgaben, Dateien, Fotos und Einstellungen liegen unter
 * „Mehr" — als sichtbare Liste, nicht in einem Wischmenü (Anf. 65).
 *
 * SOS steht bewusst NICHT hier drin. Es ist kein Bereich unter Bereichen,
 * sondern ein Knopf, der auf jedem Bildschirm sichtbar bleibt (`SOS_ITEM`,
 * gerendert in `App.tsx`) — unten rechts, wo bei einhändiger Bedienung der
 * Daumen liegt. Wer ihn in diese Liste zurückschiebt, macht ihn beim Scrollen
 * unerreichbar.
 */

export const NAV_ITEMS = [
  { id: 'familie',  icon: '🏠', label: 'Familie' },
  { id: 'chat',     icon: '💬', label: 'Chats' },
  { id: 'anrufen',  icon: '📞', label: 'Anrufe' },
  { id: 'standort', icon: '📍', label: 'Standort' },
  { id: 'status',   icon: '❤️', label: "Wie geht's?" },
  { id: 'mehr',     icon: '⋯',  label: 'Mehr' },
] as const

/** Immer sichtbar, nie in einem Menü (Anf. 28/61). */
export const SOS_ITEM = { id: 'sos', icon: '🚨', label: 'SOS' } as const

export type RouteId = (typeof NAV_ITEMS)[number]['id'] | typeof SOS_ITEM.id

/** Bereiche unter "Mehr" — vorhanden, aber nicht in der Reiterleiste. */
export const SECONDARY_ITEMS = [
  { id: 'suche',        icon: '🔍', label: 'Suchen' },
  { id: 'fotos',        icon: '📷', label: 'Fotos' },
  { id: 'dateien',      icon: '📁', label: 'Dateien' },
  { id: 'kalender',     icon: '📅', label: 'Kalender' },
  { id: 'aufgaben',     icon: '✅', label: 'Aufgaben' },
  { id: 'notizen',      icon: '📝', label: 'Notizen' },
  { id: 'mitglieder',   icon: '👪', label: 'Familie verwalten' },
  { id: 'einstellungen',icon: '⚙️', label: 'Einstellungen' },
] as const

/**
 * Zerlegt den Hash in Bereich und optionale Raum-ID.
 *
 * `#chat/<roomId>` gibt es seit Phase 8: `start-aktionen.ts` schreibt ihn,
 * wenn jemand auf der Familienseite auf „Nachricht" tippt. Gelesen hat ihn bis
 * hierher **niemand** — der Hash passte auf keinen Bereich, und die App fiel
 * auf die Familienseite zurück. Ein Tipp auf „Nachricht" führte also dorthin,
 * wo man schon war. Der Test dazu war grün, weil er die Rückrufe zählt und
 * nicht, wo man landet.
 */
export function routeLesen(hash: string): { bereich: string; raum: string | null } {
  const roh = hash.replace(/^#/, '')
  // Ein „?foto=1" hängt `start-aktionen.ts` an. Es gehört nicht zur ID.
  const [pfad] = roh.split('?')
  const teile = (pfad ?? '').split('/')
  const bereich = teile[0] ?? ''
  return { bereich, raum: teile[1] ?? null }
}
